import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalContainer from 'components/ModalContainer';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';

import QuestionBlock from '../../Questions/QuestionBlock';
import QuestionItem from '../../Questions/QuestionItem';

import * as S from './styles';

const { getEvaluation } = endpoints;

const PreviewMediation = ({ isOpen, setIsOpen, overlayData }) => {
  const { idMediator, idEvaluation } = overlayData;

  const [questionsQuantity, setQuestionsQuantity] = useState(0);
  const [mediationQuestions, setMediationQuestions] = useState([]);

  const [evaluation] = useFetch(
    `${getEvaluation}/0/${idEvaluation}/${idMediator}/0/0`
  );

  useEffect(() => {
    if (!idMediator || !idEvaluation) return setIsOpen(false);

    (async () => {
      const { respostas } = await evaluation;

      const allQuestions = respostas?.map(question => {
        const { descricao, blocos } = question;

        const blockInfos = blocos.map(({ nome, questoes }) => {
          setQuestionsQuantity(current => current + questoes?.length);

          return {
            blockName: nome,
            questions: questoes,
          };
        });

        return {
          areaName: descricao,
          blockInfos,
        };
      });

      setMediationQuestions(allQuestions);
    })();
  }, [evaluation, idEvaluation, idMediator]);

  const renderQuestions = question =>
    question.map(({ nome }) => (
      <QuestionItem>
        <S.Question>{nome}</S.Question>
      </QuestionItem>
    ));

  const renderAreaContent = data =>
    data.map(({ blockName, questions }) => (
      <>
        <QuestionBlock blockName={blockName} />
        {renderQuestions(questions)}
      </>
    ));

  return (
    <ModalContainer
      headText="Pré-visualização da mediação"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <S.Small>
        {`${
          questionsQuantity > 1
            ? `${questionsQuantity} itens`
            : `${questionsQuantity} item`
        }`}
      </S.Small>
      <S.MediationArea>
        {mediationQuestions?.map(({ areaName, blockInfos }) => (
          <>
            <S.AreaName>{areaName}</S.AreaName>
            {renderAreaContent(blockInfos)}
          </>
        ))}
      </S.MediationArea>
    </ModalContainer>
  );
};

export default PreviewMediation;

PreviewMediation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  overlayData: PropTypes.arrayOf(
    PropTypes.shape({
      idMediator: PropTypes.number,
      idEvaluation: PropTypes.number,
    })
  ).isRequired,
};
